import { motion } from "framer-motion";

const ToolTile = ({ title, level }) => {
    return (
        <div className="flex flex-col items-center gap-2">
            <div className="relative w-20 h-28 border-2 border-white/30 rounded-xl overflow-hidden bg-white/5">
                <motion.div
                    initial={{ height: 0 }}
                    whileInView={{ height: `${level}%` }}
                    transition={{ duration: 1.2, ease: "easeOut" }}
                    viewport={{ once: true }}
                    className="absolute bottom-0 left-0 w-full bg-gradient-to-t bg-tertiary"
                />
                <div className="absolute inset-0 flex items-center justify-center font-bold text-white">
                    {level}%
                </div>
            </div>
            <span className="text-sm md:text-base font-medium text-center">
                {title}
            </span>
        </div>
    );
};

export default ToolTile;